import { render, staticRenderFns } from "./customsDeclaration.vue?vue&type=template&id=4eec8260&scoped=true"
import script from "./customsDeclaration.vue?vue&type=script&lang=js"
export * from "./customsDeclaration.vue?vue&type=script&lang=js"
import style0 from "./customsDeclaration.vue?vue&type=style&index=0&id=4eec8260&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eec8260",
  null
  
)

export default component.exports